/**
 * The `/web/admin/*` endpoints return their DTO (or `204`) directly rather than
 * the `{ success, message }` envelope used elsewhere, so failures are read off
 * the HTTP status and Spring's error body.
 *
 * Shared by the subscription and payment surfaces, which both speak this
 * dialect.
 */
export const throwApiError = async (
  response: Response,
  fallback: string,
): Promise<never> => {
  let message = fallback;
  try {
    const body: unknown = await response.json();
    if (
      body !== null &&
      typeof body === "object" &&
      "message" in body &&
      typeof (body as { message: unknown }).message === "string" &&
      (body as { message: string }).message.length > 0
    ) {
      message = (body as { message: string }).message;
    }
  } catch {
    // Empty or non-JSON error body — keep the fallback message.
  }
  throw new Error(message);
};
